import {useSearchOptions} from "../../hooks/useSearchOptions";
import {useGetInventoryListURL} from "./useInventoryData";

export const useInventorySearchOptions = () => {
  const {inventoryListURL} = useGetInventoryListURL();
  const options = useSearchOptions(inventoryListURL, ["name", "location__name"], false);

  const searchOptions = [
    {
      category: {label: "Name", value: "name"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.name,
    },
    {
      category: {label: "Location", value: "location__name"},
      operator: ["=", "contains"],
      isAllowCustomValue: true,
      options: options.location__name,
    },
  ];

  return {searchOptions};
};
